import { InfoOutlined } from '@mui/icons-material';
import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  Select as MuiSelect,
  type SelectProps as MuiSelectProps,
} from '@mui/material';
import { forwardRef } from 'react';

import { Tooltip } from '../Tooltip/Tooltip';

export type SelectProps = MuiSelectProps<string> & {
  infoTooltip?: string;
  helperText?: string;
};

/* any is okay here since we pass this ref to the `inputRef` prop of the MUI Select
an that is typed as React.Ref<any> */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type SelectRef = any;

export const Select = forwardRef<SelectRef, SelectProps>(function Select(
  { id, label, fullWidth = true, children, required, error, helperText, size = 'small', infoTooltip, ...rest },
  ref
) {
  return (
    <FormControl
      fullWidth={fullWidth}
      required={required}
      error={error}
      size={size}
      sx={{ display: 'flex', flexDirection: 'row', gap: 1, ...rest.sx }}
    >
      <Box
        sx={{
          width: fullWidth ? '100%' : null,
        }}
      >
        {label ? (
          <InputLabel id={`${id}-label`} htmlFor={id} required={required}>
            {label}
          </InputLabel>
        ) : null}
        <MuiSelect
          fullWidth={fullWidth}
          labelId={`${id}-label`}
          label={label}
          inputRef={ref}
          error={error}
          size={size}
          sx={{
            minWidth: 100,
          }}
          {...rest}
          inputProps={{ id: id, ...rest.inputProps }}
        >
          {children}
        </MuiSelect>
        {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
      </Box>
      {infoTooltip ? (
        <Tooltip title={infoTooltip}>
          <InfoOutlined sx={{ marginTop: 1 }} />
        </Tooltip>
      ) : null}
    </FormControl>
  );
});
